export default {
  patients: [],
  patient: {},
  files: [],
  requests: [],
  medResults: [],
  probResults: [],
  permissions: [],
  individualPermissions: [],
  preliminaryPermissions: [],
  patientsCount: 0,
  patientsOffset: 0,
  patientsNext: 0,
  searchTermLastName: null,
  searchTermFirstName: null,
  searchTermBirthdate: null,
  searchOrder: null,
  externalUploadLink: null,
  sharedFilesExpiration: null
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/state.js